import { RouteObject } from 'react-router-dom';
import HomePageLayoutLazy from './layout/HomePageLayout/HomePageLayout.lazy';
import LoginPageLazy from './pages/LoginPage/LoginPage.lazy';
import AdminPageLayoutLazy from './layout/AdminPageLayout/AdminPageLayout.lazy';
import BookingsLazy from './containers/Bookings/Bookings.lazy';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePageLayoutLazy/>
  },
  {
    path: '/login',
    element: <LoginPageLazy />,
  },
  {
    path: '/admin/',
    element: <AdminPageLayoutLazy/>,
    children: [
      {
        path: 'bookings',
        element: <BookingsLazy />
      }
    ],
  },
];

export default routes;
